export default {
	getContractID: (state) => state.contractID,
	getDataContract: (state) => state.contract,
	getTotalRecords: (state) => state.TotalRecords,
}
